import { ActionsObservable, combineEpics, Epic, ofType, StateObservable } from 'redux-observable';
import { filter, map, withLatestFrom } from 'rxjs/operators';
import { Actions, ActionTypes, TAction } from '../Actions/Actions';
import { IGameState } from '../Store/store';

const comboEpic: Epic<TAction, TAction, IGameState> = (
    action$: ActionsObservable<TAction<string, number>>,
    state$: StateObservable<IGameState>
) => {
    return action$.pipe(
        ofType(ActionTypes.SET_MULTIPLIER),
        withLatestFrom(state$),
        filter(([action, state]) => state.StateScore.multiplier === 10 && action.payload === 1),
        map(() => Actions.resetComboMeter(true))
    );
};

const scoreEpic = combineEpics(comboEpic);

export default scoreEpic;
